<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="13.281" height="12.255" viewBox="0 0 13.281 12.255">
  <defs>
    <clipPath id="clip-path">
      <rect id="Rettangolo_13960" data-name="Rettangolo 13960" width="13.281" height="12.255" transform="translate(0 0)" fill="#3b3b3b"/>
    </clipPath>
  </defs>
  <g id="Raggruppa_17082" data-name="Raggruppa 17082" transform="translate(0 0)">
    <g id="Raggruppa_17066" data-name="Raggruppa 17066" clip-path="url(#clip-path)">
      <path id="Tracciato_11495" data-name="Tracciato 11495" d="M4.045,4.045,6.037,2.053V8.391a.571.571,0,0,0,.6.6.57.57,0,0,0,.6-.6V2.053L9.237,4.045a.6.6,0,0,0,.845-.845L7.063.182a.583.583,0,0,0-.845,0L3.2,3.2a.6.6,0,0,0,.845.845" fill="#3b3b3b"/>
      <path id="Tracciato_11496" data-name="Tracciato 11496" d="M13.281,6.037a.6.6,0,0,0-.6-.6.57.57,0,0,0-.6.6v5.01H1.208V6.037a.65.65,0,0,0-.6-.6.606.606,0,0,0-.6.6v5.01a1.212,1.212,0,0,0,1.208,1.208H12.074a1.211,1.211,0,0,0,1.207-1.208Z" fill="#3b3b3b"/>
    </g>
  </g>
</svg>
